import React,{useState} from 'react';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiPlay}=FiIcons;
const JOE_BEAL_VIDEO_ID='zIlhwxC7j2U';

const JoeBealStory=()=> {
  const [isPlaying,setIsPlaying]=useState(false);
  const thumbnailUrl=`https://img.youtube.com/vi/${JOE_BEAL_VIDEO_ID}/hqdefault.jpg`;

  return (
    <section className="border-y border-black bg-black px-4 py-20 text-white sm:px-8 md:py-28">
      <div className="mx-auto grid max-w-6xl items-center gap-12 lg:grid-cols-2">
        <div>
          <p className="font-sans text-xs font-black uppercase tracking-[0.24em] text-yellow-400">
            Closer story
          </p>
          <h2 className="mt-5 text-4xl font-black uppercase leading-[0.98] tracking-tight sm:text-5xl">
            Meet Joe Beal.
          </h2>
          <p className="mt-7 max-w-xl text-xl leading-relaxed text-neutral-300">
            Joe knows his time is worth more in front of buyers than behind a screen. Watch his story and see what happens when a closer gets the admin work off their plate.
          </p>
        </div>

        <div className="overflow-hidden border-2 border-yellow-400 bg-neutral-900 shadow-[8px_8px_0_#facc15]">
          {isPlaying ? (
            <iframe
              className="aspect-video w-full"
              src={`https://www.youtube.com/embed/${JOE_BEAL_VIDEO_ID}?autoplay=1&rel=0&modestbranding=1`}
              title="Joe Beal's story"
              allow="accelerometer;autoplay;clipboard-write;encrypted-media;gyroscope;picture-in-picture"
              allowFullScreen
            />
          ) : (
            <button
              onClick={()=> setIsPlaying(true)}
              className="group relative block aspect-video w-full overflow-hidden"
              aria-label="Play Joe Beal's story"
            >
              <img
                src={thumbnailUrl}
                alt="Joe Beal's story"
                className="h-full w-full object-cover opacity-70 transition duration-300 group-hover:scale-105 group-hover:opacity-90"
              />
              <span className="absolute inset-0 flex items-center justify-center">
                <span className="flex h-16 w-16 items-center justify-center rounded-full bg-yellow-400 text-black transition group-hover:scale-110">
                  <SafeIcon icon={FiPlay} className="ml-1 text-3xl" />
                </span>
              </span>
              <span className="absolute bottom-4 left-4 bg-black px-3 py-2 font-sans text-xs font-black uppercase tracking-wide text-white">
                Watch Joe&apos;s Story
              </span>
            </button>
          )}
        </div>
      </div>
    </section>
  );
};

export default JoeBealStory;